// src/locales/en/creditNote.js
export const creditNote = {
  // Page titles
  creditNotes: 'Credit Notes',
  allCreditNotes: 'All Credit Notes',
  createCreditNote: 'Create Credit Note',
  createCreditNoteDescription: 'Issue a credit note against an original order',
  creditNoteDetails: 'Credit Note Details',
  viewAndManageAllCreditNotes: 'View and manage all credit notes',

  // List columns
  creditNoteNumber: 'Credit Note #',
  customer: 'Customer',
  originalOrder: 'Original Order',
  sourceType: 'Source',
  amount: 'Amount',
  balance: 'Balance',
  appliedAmount: 'Applied Amount',
  remainingAmount: 'Remaining Amount',
  reason: 'Reason',
  createdBy: 'Created By',
  createdAt: 'Created At',
  status: 'Status',
  actions: 'Actions',

  // Status labels — used via t(`creditNote.status_${note.status}`)
  status_issued:    'Issued',
  status_applied:   'Applied',
  status_cancelled: 'Cancelled',

  // Source type labels — used via t(`creditNote.sourceType_${note.sourceType}`)
  sourceType_return:           'Return',
  sourceType_price_adjustment: 'Price Adjustment',
  sourceType_goodwill:         'Goodwill',

  // Form fields
  selectCustomer: 'Select Customer',
  allCustomers: 'All Customers',
  selectOriginalOrder: 'Select Order',
  amountPlaceholder: 'Enter credit note amount',
  reasonPlaceholder: 'Enter reason for this credit note...',
  notes: 'Notes',
  notesPlaceholder: 'Add any notes about this credit note...',

  // Actions
  create: 'Create Credit Note',
  issueCreditNote: 'Issue Credit Note',
  save: 'Save',
  applyToOrder: 'Apply to Order',
  applyCreditNote: 'Apply Credit Note',
  cancelCreditNote: 'Cancel Credit Note',
  print: 'Print',
  printCreditNote: 'Print Credit Note',
  backToCreditNotes: 'Back to Credit Notes',

  // Confirmations
  confirmApply: 'Apply this credit note to the selected order?',
  confirmCancel: 'Are you sure you want to cancel this credit note? This action cannot be undone.',
  cancellationReason: 'Reason for Cancellation',
  cancellationReasonPlaceholder: 'Enter reason for cancellation...',
  applyAmount: 'Amount to Apply',

  // Filters
  filterByStatus: 'Filter by Status',
  filterBySourceType: 'Filter by Source',
  filterByCustomer: 'Filter by Customer',
  dateFrom: 'From',
  dateTo: 'To',
  searchCreditNotes: 'Search by credit note #, customer...',
  allStatuses: 'All Statuses',
  allSourceTypes: 'All Sources',

  // Success / error messages
  creditNoteCreatedSuccessfully: 'Credit note created successfully',
  creditNoteAppliedSuccessfully: 'Credit note applied successfully',
  creditNoteCancelledSuccessfully: 'Credit note cancelled successfully',
  failedToCreateCreditNote: 'Failed to create credit note',
  failedToApplyCreditNote: 'Failed to apply credit note',
  failedToCancelCreditNote: 'Failed to cancel credit note',
  failedToLoadCreditNotes: 'Failed to load credit notes',
  failedToLoadCreditNoteDetails: 'Failed to load credit note details',
  someFieldsRequired: 'Please fix the highlighted fields before submitting',

  // Validation
  customerRequired: 'Please select a customer',
  originalOrderRequired: 'Please select an order',
  amountRequired: 'Amount is required',
  amountMustBePositive: 'Amount must be greater than zero',
  amountExceedsOrderBalance: 'Amount cannot exceed the order\'s outstanding balance',
  reasonRequired: 'Reason is required',
  applyAmountExceedsRemaining: 'Apply amount cannot exceed the remaining credit note balance',
  applyAmountExceedsOrderBalance: 'Apply amount cannot exceed the selected order\'s outstanding balance',

  // Empty states
  noCreditNotesFound: 'No credit notes found',
  noCreditNotesFoundDescription: 'Try adjusting the current filters to see more credit notes.',
  noCreditNotesYet: 'No credit notes yet.',
  noCreditNotesYetDescription: 'Create your first credit note to begin tracking customer refunds.',
  noCreditNotesMatchFilters: 'No credit notes match your current filters',
  issueFirstCreditNote: 'Issue First Credit Note',

  na: 'N/A',
};
